import { Component, OnInit, OnDestroy } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { DomService } from 'app/components/dom/dom.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  catalogueProperties: object = {
    translations: []
  };

  constructor(public catalogueService: CatalogueService, public utilsService: UtilsService,
  private domService: DomService) { }

  goToMaps() {
    window.open('https://www.google.com/search?sca_esv=570303733&rlz=1C1GCEA_en&tbs=lf:1,lf_ui:4&tbm=lcl&sxsrf=AM9HkKkMEs8yt7UPIs7jdt2Kvh08Fbb9pw:1696335964826&q=fira+barcelona&rflfq=1&num=10&rllag=41364234,2138499,1385&ved=2ahUKEwiLlun079mBAxVlVqQEHY4CBqUQtgN6BAgdEAI#rlfi=hd:;si:;mv:[[41.3749211,2.1504537999999997],[41.3535487,2.1265443]];tbs:lrf:!1m4!1u3!2m2!3m1!1e1!2m1!1e3!3sIAE,lf:1,lf_ui:4', '_blank');
  }

  ngOnInit() {
    
    this.catalogueService.getDataProperties().subscribe(data => {
      this.catalogueProperties = data;
    });

    this.domService.addClassToBody('bg-gray');
  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}
